import { render, staticRenderFns } from "./ReportRate.vue?vue&type=template&id=2263d73a"
import script from "./ReportRate.vue?vue&type=script&lang=js"
export * from "./ReportRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports